<div class="container-tig">
    <div class="title">
        <h4>字体下载</h4>
    </div>
    <div class="Font-style-debugger">
        <div class="font-component row " [ngClass]="{'row-clos-md-2': sm , 'row-clos-md-3': !sm }" id="">
            <div class="In_box" id="InBox">
                <div class="inIcon " (click)="OpenClose()">
                    <svg width="1em" height="1em" id="iconPan" viewBox="0 0 16 16" class="bi bi-pencil" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5L13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175l-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                    </svg>
                </div>
                <div class="mgl position-relative " style="z-index: 2;">
                    <span class="position-absolute" style="top: -10px;">
                        <input type="text" maxlength="30" class="inText font-oss" id="In" placeholder="输入文字，即时体验" [(ngModel)]="inText"> 
                    </span>
                </div>
            </div>
            <div class="col d-flex align-items-center justify-content-lg-center padding-left-48">
                <div class="font_resize">
                    <div class=" d-flex align-items-center justify-content-center">
                        <div class="sm-t" (click)="smFs()">
                            <span class="big-t" id="bt">T</span>
                            <span class="min-t" id="mt">T</span>
                        </div>
                    </div>
                </div>
                <span *ngIf="!sm" class="font-size-slider w-100">
                    <ng5-slider [(value)]="value" [options]="options"></ng5-slider>
                </span>
            </div>
            <div class="col d-flex justify-content-center align-items-center ">
                <div class="color-icon position-relative">
                    <input type="color" class="color-b position-absolute" [(ngModel)]="bgColor">
                    <input type="color" class="color-w position-absolute" [(ngModel)]="color">
                </div>
                <div class="reset" (click)="Reset()">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-clockwise" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                    </svg>
                </div>
            </div>
            <div class="col d-flex align-items-center justify-content-end">
                <div class="d-help">
                    <a [routerLink]="['/usageMethod/install']">
                    安装指南
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="font_container row  row-cols-3 row-cols-sm-5 row-cols-md-7">
        <div class="col" *ngFor="let item of textCont; let i=index">
            <a class="font_cont d-flex justify-content-between position-relative" [ngStyle]="Color()" [routerLink]="['/Download/1']">
                <div class="font_style mgl" id="getHeight">
                    <span *ngIf="text === ''" [ngStyle]="font_size()">{{ item }}</span>
                    <span *ngIf="text !== ''" [ngStyle]="font_size()">{{ text }}</span>
                </div>
                <div class="fontType_title">
                    <span class="font_name mgl font-oss fz-18">  ᠮᠣᠩᠭᠣᠯ ᠪᠢᠴᠢᠭ ᠤᠨ ᠰᠣᠨᠢᠨ ᠲᠢᠭ -</span>
                    <span class="font_name" style="writing-mode: tb;">
                    蒙古文无衬线报体
                    </span>
                    <span class="Developers_logo">
                        <img src="/assets/images/onon-logo.png" alt="蒙古文无衬线报体 - Logo">
                    </span>
                    <!-- <span class="Developers_name " style="writing-mode: tb;">
                        onon Fonts
                    </span> -->
                </div>
                <div class="asthenia_bottom position-absolute" [ngStyle]="astheniaColor()"></div>
            </a>
        </div>
    </div>
</div>